module.exports = __webpack_public_path__ + "fonts/CangErYuMoW02-2.61f4a9ba.ttf";